//libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// components
import { UxAngleDown } from '/react4xp/components/Svg/Ux/Angle'
import RichText from '../RichText'

// prop types
export interface AccordionProps {
    question: string
    answer: string
    accordionColor?: 'red' | 'yellow' | string
    isWhite?: boolean
}

export default function Accordion({
    question,
    answer,
    accordionColor,
    isWhite
}: AccordionProps) {

    const [isActive, setIsActive] = useState(false)

	const toggle = () => {
		setIsActive((prev) => !prev)
	}

    // custom bg color
    const customBgColor = accordionColor && !['red', 'yellow'].includes(accordionColor) ? { backgroundColor: accordionColor } : {}

    return (
        <div
            className={clsx(
                'accordion-component',
                isActive && 'accordion-component--is-active',
                accordionColor === 'red' && 'accordion-component--is-red',
                accordionColor === 'yellow' && 'accordion-component--is-yellow'
            )}
        >

            <button
                className={clsx('accordion-component__title', isWhite && 'white')}
                onClick={toggle}
            >

                <span
                    style={customBgColor}
                    className='accordion-component__title-bg'
                ></span>

                <span className='accordion-component__title-text'>
                    <UxAngleDown />
                    {question}
                </span>

            </button>

            <div
                className={clsx(
                    'accordion-component__content text-small',
                    isWhite && 'white'
                )}
                style={customBgColor}
            >
                <div>
                    <RichText content={answer} />
                </div>
            </div>

        </div>
    )
}